import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';


declare var toastr: any;

@Injectable()
export class PermissionGuard implements CanActivate {

    constructor(
        private router: Router,
        private translate: TranslateService
    ) { }

    canActivate( route: ActivatedRouteSnapshot, state: RouterStateSnapshot ) {

        let permissions = route.data["permissions"] as Array<string>;

        return true;

        // this.translate.get( ['ACCESS_DENIED', 'YOU_HAVE_NO_PERMISSION_TO_ACCESS_THIS_PAGE'] ).subscribe( res => {
        //     toastr.options = {
        //         "closeButton": true,
        //         "positionClass": "toast-bottom-right"
        //     }
        //     toastr.error( res.YOU_HAVE_NO_PERMISSION_TO_ACCESS_THIS_PAGE, res.ACCESS_DENIED );
        // });

        // return false;
    }

}
